// The saved Sage transcript's shape on the way to /api/tutor/session — shared
// by the website's chat and the server's validator, with no server imports so
// the client bundle can use it. The app has its twin in
// apps/mobile/src/state/sage.ts (saveSageSession).

/** The most messages one saved transcript holds: the newest are kept. */
export const MAX_SAVED_TRANSCRIPT_MESSAGES = 40

/**
 * The newest messages the server keeps, and the conversation's revision —
 * how many messages it has IN ALL, counted before the cap.
 *
 * The server orders saves by the revision. A conversation only grows, so a
 * lower one is an older save arriving late; the array's length can't tell
 * once a chat passes the cap, because every save is then exactly 40 long
 * (build-7 retest 0f019b4c, F5). Sending the whole thread instead was a 400
 * from the 21st exchange, so a long website chat silently stopped being saved.
 */
export function savedTranscript<T>(messages: T[]): { messages: T[]; revision: number } {
  return {
    messages: messages.slice(-MAX_SAVED_TRANSCRIPT_MESSAGES),
    revision: messages.length,
  }
}
